import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Loader as DefaultLoader, MITLoggedOut } from '@mit/hui';
import { useStoreActions, useStoreState } from 'Store'
import { AccountController } from 'Api/controller'
import { Loader } from './Loader'
import { ConfigController } from 'Api/controller/ConfigController';

export const Initialization: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [hasAccess, setHasAccess] = useState<boolean>(false)
  const [tokenExpired, setTokenExpired] = useState<boolean>(false)
  const { hasOutage } = useStoreState(state => state.regionModel)
  const { updateProfile } = useStoreActions(action => action.profileModel)
  const { initializeStep, setRequiredSteps } = useStoreActions(action => action.stepModel)
  const { setTexts, setStatus, setIsGlobalEnabled } = useStoreActions(action => action.globalModel)

  const location = window.location
  const path = location.pathname
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')

  const App = lazy(() => import('Components/App'));

  useEffect(() => {

        if (token === null) {
          setHasAccess(false)
          setIsLoading(false)
        } else {
          sessionStorage.setItem('AccessToken', token)
          const accountController = new AccountController()
        
          try {
            const configController = new ConfigController()
            configController.getAtlasConfig().then(data => {
            if (data["global.enabled"] === "true") {
                setIsGlobalEnabled(true)
              }
              console.log(data)
            })
          } catch (error) { 
            console.error(error)
          }


          accountController
            .getStatus()
            .then(data => {
              setTokenExpired(false)
              updateProfile({
                display_name: `${data.firstName ?? ''} ${data.lastName ?? ''}`,
                mitid: data.mitId ?? '',
                krb_name: data.krbName !== null && !(data.krbName ?? '').includes('#') ? data.krbName : '',
                first_name: data.firstName ?? '',
                last_name: data.lastName ?? ''
              })
              setStatus(data)
              initializeStep(data.nextStep)
              setRequiredSteps((data.steps as any) ?? [])
              // initializeStep('completed')

              setIsLoading(false)
              setHasAccess(true)

              accountController
                .getTexts()
                .then(data => setTexts(data))
                .catch(error => console.error(error))
            })
            .catch(error => {
              console.error(error)
              // TODO: Show error page with message depending on response
              setIsLoading(false)
              setTokenExpired(true)
              setHasAccess(false)
            })
        }
  }, [])

  if (isLoading || hasOutage) {
    return (
      <DefaultLoader
        contactEmail='reactTemplate'
        hasAccess={hasAccess}
        name='Kerberos Account Registration'
        isLoading={isLoading}
        type={hasOutage ? 'outage' : 'mit'}
      />
    )
  }

  if (!hasAccess || tokenExpired) {
    return <Loader type={tokenExpired ? 'expired' : 'no-access'} />
  }

  return (
    <Routes>
      {path !== '/logout' && (
        <Route path='/' element={<Suspense fallback={<> </>}><App /></Suspense>} />
      )}
      <Route path='/logout' element={<MITLoggedOut />} />
    </Routes>
  );
};
